// extracted by mini-css-extract-plugin
export default {"link":"FullWidthWiraaAds_link__FjObA","container":"FullWidthWiraaAds_container__XBQcA"};